import * as React from 'react'

import { Typography } from './design-system/typography'
import './folder-empty-state.css'

interface IProps {}

export const FolderEmptyState: React.FC<IProps> = () => (
  <div className="flex min-w-[850px] flex-col gap-6">
    <InstallPluginBanner />
    <div className="grid grid-cols-[2fr_1fr_1fr] gap-[22px]">
      <TutorialCard />
      <PlaygroundCard />
      <div className="grid grid-rows-[1fr_1fr] gap-[20px]">
        <JoinCommunityCard />
        <FollowUpdatesCard />
      </div>
    </div>
  </div>
)

interface ICardProps {
  bgStartClass: string
  bgEndClass: string
}

const FollowUpdatesCard: React.FCC = () => (
  <a href="https://www.aninix.com/twitter" target="_blank" rel="noreferrer">
    <RoundedBackgroundCard
      bgStartClass="from-[#D5F5CC]"
      bgEndClass="to-[#D7E6FA]"
    >
      <div className="relative flex h-full flex-col justify-end">
        <div className="absolute left-1/2 top-[calc(100%-140px)] h-[720px] w-[720px] -translate-x-1/2 transform-gpu rounded-full bg-[#18A0FB] blur-[120px] transition-transform duration-300 group-hover:-translate-y-10" />
        <div className="absolute left-0 top-1/2 -translate-y-[65%]">
          {followUpdatesArt}
        </div>
        <div className="absolute inset-0 flex flex-row items-end justify-start gap-2 p-4">
          {followUpdatesIcon}
          <Typography className="text-white" style="Body3Medium">
            Product updates
          </Typography>
        </div>
      </div>
    </RoundedBackgroundCard>
  </a>
)

const followUpdatesArt = (
  <svg
    className="origin-top-bottom transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110"
    width="145"
    height="127"
    viewBox="0 0 145 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_74_1545)">
      <path
        d="M109.441 1.67962C105.245 5.34024 100.77 7.56955 96.2331 10.3432C89.182 5.68444 81.0646 7.49715 74.1255 12.4519C67.1865 17.4067 64.0267 25.8213 66.3079 33.8908L67.602 38.7204C52.0373 43.3206 36.167 39.9224 23.7886 29.7547C23.7886 29.7547 13.2101 71.0652 57.3422 77.7042C49.9149 86.1493 41.9863 92.6271 30.9526 95.128C49.2623 99.555 67.4754 97.8841 81.3762 89.4696C97.3205 79.814 108.057 63.0488 108.309 42.1775C108.354 35.8383 107.527 29.523 105.852 23.4088C105.53 22.2062 109.558 8.06694 109.439 1.67479L109.441 1.67962Z"
        stroke="url(#paint0_linear_74_1545)"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_74_1545"
        x="8.01107"
        y="-9.65923"
        width="116.097"
        height="125.166"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_1545"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_74_1545"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_74_1545"
        x1="61.0014"
        y1="14.0864"
        x2="81.7463"
        y2="91.5077"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8F5FE" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
)

const followUpdatesIcon = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 6.68909H7C6.46957 6.68909 5.96086 6.8998 5.58579 7.27487C5.21071 7.64995 5 8.15865 5 8.68909V17.6891C5 18.2195 5.21071 18.7282 5.58579 19.1033C5.96086 19.4784 6.46957 19.6891 7 19.6891H16C16.5304 19.6891 17.0391 19.4784 17.4142 19.1033C17.7893 18.7282 18 18.2195 18 17.6891V14.6891M14 7.68909C14 8.48474 14.3161 9.2478 14.8787 9.81041C15.4413 10.373 16.2044 10.6891 17 10.6891C17.7956 10.6891 18.5587 10.373 19.1213 9.81041C19.6839 9.2478 20 8.48474 20 7.68909C20 6.89344 19.6839 6.13038 19.1213 5.56777C18.5587 5.00516 17.7956 4.68909 17 4.68909C16.2044 4.68909 15.4413 5.00516 14.8787 5.56777C14.3161 6.13038 14 6.89344 14 7.68909Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const JoinCommunityCard: React.FCC = () => (
  <a
    href="https://www.aninix.com/discord"
    className="h-inherit"
    target="_blank"
    rel="noreferrer"
  >
    <RoundedBackgroundCard
      bgStartClass="from-[#D5F5CC]"
      bgEndClass="to-[#D7E6FA]"
    >
      <div className="relative flex h-full flex-col justify-end">
        <div className="absolute left-1/2 top-[calc(100%-140px)] h-[720px] w-[720px] -translate-x-1/2 transform-gpu rounded-full bg-[#7B61FF] blur-[120px] transition-transform duration-300 group-hover:-translate-y-10" />
        <div className="absolute left-0 top-1/2 -translate-y-[75%]">
          {discordArt}
        </div>
        <div className="absolute inset-0 flex flex-row items-end justify-start gap-2 p-4">
          {discordIcon}
          <Typography className="text-white" style="Body3Medium">
            Community
          </Typography>
        </div>
      </div>
    </RoundedBackgroundCard>
  </a>
)

const discordArt = (
  <svg
    className="origin-top-bottom transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110"
    width="143"
    height="123"
    viewBox="0 0 143 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_74_1544)">
      <g filter="url(#filter0_d_74_1544)">
        <path
          d="M92.8585 68.619C94.1526 73.4486 103.985 81.1667 106.4 80.5197C113.644 78.5785 117.925 68.8025 119.421 61.5015C120.486 52.5873 114.288 32.6832 97.2949 7.90189C88.9446 4.88532 81.0719 5.31248 73.6204 6.48088L71.4146 17.0261C64.6381 17.6435 58.0174 19.4175 51.8401 22.2711L44.6427 14.2455C37.6053 16.9593 30.5737 20.5258 24.8505 27.3133C22.5248 57.271 27.1095 77.6074 32.4881 84.7952C37.4345 90.3699 46.0297 96.6959 53.2741 94.7547C55.6889 94.1077 60.3452 82.5073 59.0511 77.6777M51.1598 77.2039C69.3576 77.5042 83.8465 73.6219 99.4561 64.263M50.166 54.1765C50.5092 55.4574 51.3472 56.5495 52.4957 57.2125C53.6441 57.8756 55.0089 58.0553 56.2898 57.712C57.5706 57.3688 58.6627 56.5308 59.3258 55.3824C59.9888 54.234 60.1685 52.8692 59.8253 51.5883C59.4821 50.3074 58.6441 49.2153 57.4957 48.5523C56.3472 47.8892 54.9825 47.7096 53.7016 48.0528C52.4207 48.396 51.3286 49.234 50.6655 50.3824C50.0025 51.5308 49.8228 52.8956 50.166 54.1765ZM79.1438 46.4119C79.487 47.6928 80.325 48.7849 81.4734 49.448C82.6219 50.111 83.9866 50.2907 85.2675 49.9475C86.5484 49.6043 87.6405 48.7663 88.3036 47.6178C88.9666 46.4694 89.1463 45.1046 88.8031 43.8237C88.4598 42.5428 87.6219 41.4508 86.4734 40.7877C85.325 40.1247 83.9602 39.945 82.6793 40.2882C81.3984 40.6314 80.3063 41.4694 79.6433 42.6178C78.9803 43.7663 78.8006 45.131 79.1438 46.4119Z"
          stroke="url(#paint0_linear_74_1544)"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_74_1544"
        x="9.5638"
        y="-5.73421"
        width="124.639"
        height="118.85"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_1544"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_74_1544"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_74_1544"
        x1="111.873"
        y1="32.371"
        x2="76.6248"
        y2="106.121"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F2FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_74_1544">
        <rect
          width="120"
          height="120"
          fill="white"
          transform="translate(-4 6.57373) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
)

const discordIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9H16M8 13H14M18 4C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H13L8 21V18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const TutorialCard: React.FCC = () => (
  <a href="https://youtu.be/LzECe8iynyU" target="_blank" rel="noreferrer">
    <RoundedBackgroundCard
      bgStartClass="from-[#D5F5CC]"
      bgEndClass="to-[#D7E6FA]"
    >
      <div className="relative flex h-[350px] flex-col justify-end">
        <div className="absolute left-1/2 top-[calc(100%-140px)] h-[720px] w-[720px] -translate-x-1/2 transform-gpu rounded-full bg-[#374FD5] blur-[120px] transition-transform duration-300 group-hover:-translate-y-10" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[60%]">
          {tutorialArt}
        </div>
        <div className="absolute inset-0 flex flex-row items-end justify-start gap-2 p-4">
          {youtubeIcon}
          <Typography className="text-white" style="Body3Medium">
            Video tutorial
          </Typography>
        </div>
      </div>
    </RoundedBackgroundCard>
  </a>
)

const tutorialArt = (
  <svg
    className="overflow-visible"
    width="372"
    height="218"
    viewBox="0 0 372 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      className="origin-top transition-transform delay-150 duration-300 group-hover:scale-105"
      filter="url(#filter0_d_73_1295)"
    >
      <rect
        x="175.828"
        y="155.075"
        width="122"
        height="47"
        rx="10"
        transform="rotate(3 175.828 155.075)"
        fill="white"
      />
      <path
        d="M191.503 186.939L192.122 175.124L195.305 175.291L194.686 187.106L191.503 186.939ZM193.8 173.562C193.32 173.537 192.918 173.348 192.594 172.996C192.27 172.644 192.121 172.235 192.145 171.77C192.17 171.298 192.362 170.904 192.721 170.587C193.08 170.271 193.499 170.125 193.979 170.15C194.465 170.176 194.867 170.364 195.184 170.716C195.501 171.068 195.647 171.48 195.622 171.952C195.598 172.417 195.409 172.808 195.058 173.125C194.706 173.442 194.287 173.587 193.8 173.562ZM197.269 187.242L197.888 175.426L201.071 175.593L200.971 177.49L201.102 177.497C201.428 176.843 201.895 176.343 202.503 175.996C203.112 175.642 203.852 175.488 204.724 175.533C206.032 175.602 207.015 176.043 207.671 176.857C208.328 177.671 208.62 178.78 208.546 180.182L208.147 187.812L204.964 187.645L205.328 180.702C205.37 179.903 205.224 179.279 204.89 178.832C204.557 178.384 204.023 178.142 203.289 178.103C202.809 178.078 202.39 178.165 202.029 178.365C201.669 178.565 201.381 178.856 201.164 179.238C200.954 179.62 200.836 180.073 200.809 180.596L200.451 187.408L197.269 187.242ZM215.896 188.218L216.72 172.49L227.02 173.03L226.878 175.744L219.87 175.376L219.649 179.594L226.047 179.93L225.91 182.535L219.512 182.199L219.188 188.39L215.896 188.218ZM228.365 188.871L228.984 177.056L232.167 177.223L231.548 189.038L228.365 188.871ZM230.662 175.494C230.182 175.469 229.781 175.28 229.457 174.928C229.133 174.576 228.983 174.167 229.007 173.702C229.032 173.23 229.224 172.835 229.583 172.519C229.942 172.203 230.361 172.057 230.841 172.082C231.328 172.108 231.729 172.296 232.046 172.648C232.363 173 232.509 173.412 232.484 173.884C232.46 174.349 232.272 174.74 231.92 175.057C231.568 175.374 231.149 175.519 230.662 175.494ZM239.31 193.576C238.22 193.519 237.287 193.324 236.51 192.992C235.733 192.66 235.129 192.228 234.698 191.695C234.267 191.162 234.018 190.57 233.95 189.918L233.954 189.842L237.071 190.005L237.09 190.072C237.182 190.39 237.43 190.665 237.833 190.898C238.236 191.137 238.779 191.275 239.462 191.311C240.29 191.354 240.936 191.195 241.4 190.833C241.87 190.472 242.123 189.953 242.159 189.277L242.262 187.304L242.142 187.298C241.91 187.701 241.611 188.043 241.247 188.322C240.883 188.595 240.464 188.799 239.991 188.934C239.518 189.062 239.002 189.112 238.442 189.082C237.454 189.031 236.612 188.75 235.918 188.24C235.223 187.73 234.706 187.032 234.366 186.147C234.026 185.262 233.887 184.231 233.949 183.054L233.95 183.033C234.014 181.819 234.261 180.779 234.693 179.913C235.132 179.047 235.723 178.393 236.468 177.951C237.22 177.51 238.097 177.315 239.1 177.368C239.652 177.397 240.152 177.514 240.6 177.72C241.056 177.918 241.446 178.19 241.771 178.535C242.102 178.88 242.362 179.287 242.548 179.756L242.657 179.762L242.761 177.778L245.944 177.945L245.343 189.411C245.296 190.312 245.019 191.085 244.511 191.728C244.004 192.372 243.305 192.857 242.413 193.181C241.529 193.507 240.495 193.638 239.31 193.576ZM239.656 186.763C240.194 186.792 240.666 186.678 241.073 186.422C241.487 186.167 241.817 185.795 242.061 185.305C242.306 184.807 242.446 184.221 242.481 183.545L242.482 183.523C242.518 182.848 242.439 182.253 242.248 181.741C242.056 181.22 241.768 180.812 241.383 180.515C241.005 180.218 240.547 180.056 240.009 180.028C239.465 179.999 238.985 180.112 238.571 180.367C238.164 180.623 237.838 180.996 237.594 181.486C237.357 181.976 237.221 182.563 237.185 183.246L237.184 183.257C237.149 183.94 237.223 184.541 237.407 185.061C237.599 185.574 237.883 185.978 238.261 186.275C238.646 186.572 239.111 186.735 239.656 186.763ZM247.864 189.893L248.484 178.078L251.666 178.245L251.565 180.174L251.696 180.181C251.971 179.518 252.41 179.009 253.011 178.654C253.613 178.292 254.306 178.132 255.091 178.173C255.643 178.202 256.132 178.322 256.558 178.534C256.985 178.739 257.342 179.023 257.629 179.388C257.916 179.745 258.119 180.175 258.239 180.677L258.358 180.683C258.565 180.22 258.852 179.824 259.219 179.493C259.593 179.163 260.025 178.916 260.514 178.752C261.012 178.582 261.54 178.511 262.099 178.54C262.884 178.581 263.555 178.781 264.112 179.138C264.669 179.495 265.091 179.979 265.38 180.592C265.668 181.205 265.792 181.914 265.749 182.721L265.325 190.808L262.143 190.641L262.525 183.35C262.55 182.877 262.494 182.481 262.358 182.161C262.229 181.84 262.023 181.593 261.741 181.418C261.466 181.236 261.118 181.134 260.697 181.112C260.283 181.09 259.914 181.165 259.592 181.338C259.277 181.511 259.027 181.76 258.842 182.086C258.658 182.404 258.555 182.781 258.532 183.217L258.154 190.432L255.036 190.269L255.425 182.857C255.447 182.429 255.39 182.061 255.253 181.755C255.116 181.449 254.906 181.209 254.624 181.034C254.349 180.859 254.008 180.761 253.601 180.74C253.202 180.719 252.84 180.798 252.518 180.978C252.202 181.158 251.944 181.418 251.745 181.757C251.552 182.09 251.444 182.481 251.421 182.932L251.047 190.06L247.864 189.893ZM271.169 191.3C270.406 191.26 269.734 191.076 269.154 190.747C268.581 190.418 268.142 189.976 267.835 189.421C267.537 188.866 267.406 188.236 267.443 187.531L267.443 187.52C267.481 186.801 267.691 186.196 268.074 185.706C268.457 185.216 268.997 184.844 269.695 184.589C270.394 184.327 271.235 184.192 272.219 184.186L276.757 184.15L276.654 186.112L272.597 186.162C271.955 186.165 271.464 186.285 271.124 186.522C270.784 186.752 270.603 187.081 270.581 187.51L270.58 187.521C270.557 187.964 270.706 188.321 271.026 188.593C271.355 188.858 271.792 189.005 272.337 189.034C272.824 189.059 273.261 188.987 273.649 188.818C274.036 188.649 274.348 188.407 274.583 188.091C274.819 187.768 274.947 187.403 274.968 186.996L275.16 183.334C275.188 182.811 275.042 182.395 274.723 182.087C274.404 181.779 273.925 181.608 273.285 181.575C272.704 181.544 272.229 181.632 271.861 181.839C271.494 182.038 271.253 182.321 271.139 182.686L271.114 182.761L268.192 182.608L268.21 182.489C268.312 181.78 268.592 181.165 269.05 180.642C269.514 180.12 270.129 179.726 270.893 179.46C271.658 179.194 272.548 179.088 273.566 179.141C274.597 179.195 275.475 179.405 276.199 179.771C276.924 180.13 277.47 180.617 277.839 181.234C278.214 181.851 278.381 182.567 278.338 183.381L277.914 191.468L274.743 191.302L274.831 189.623L274.711 189.617C274.48 189.991 274.186 190.311 273.83 190.576C273.474 190.835 273.07 191.028 272.619 191.158C272.175 191.28 271.692 191.328 271.169 191.3Z"
        fill="#7B61FF"
      />
    </g>
    <g
      className="origin-top transition-transform delay-75 duration-300 group-hover:scale-105"
      filter="url(#filter1_d_73_1295)"
    >
      <rect
        x="71"
        y="118.2"
        width="177"
        height="57"
        rx="10"
        transform="rotate(-4 71 118.2)"
        fill="white"
      />
      <path
        d="M90.1026 155.96L96.1703 133.708L100.174 133.428L100.469 137.643L99.0842 137.74L94.8743 155.626L90.1026 155.96ZM93.8135 150.406L94.6895 146.926L104.82 146.218L106.172 149.542L93.8135 150.406ZM105.833 154.86L99.1745 137.734L98.8797 133.519L101.514 133.335L110.604 154.526L105.833 154.86ZM112.456 154.397L111.327 138.26L115.723 137.953L115.908 140.602L115.998 140.596C116.355 139.643 116.927 138.872 117.712 138.283C118.498 137.693 119.498 137.356 120.712 137.271C122.488 137.147 123.896 137.588 124.934 138.595C125.982 139.59 126.572 141.036 126.705 142.933L127.433 153.349L123.038 153.657L122.373 144.143C122.299 143.09 121.991 142.294 121.449 141.758C120.917 141.21 120.159 140.97 119.176 141.039C118.523 141.085 117.967 141.275 117.506 141.61C117.045 141.934 116.697 142.372 116.464 142.923C116.24 143.473 116.153 144.104 116.203 144.817L116.851 154.089L112.456 154.397ZM130.308 153.148L129.18 137.012L133.575 136.705L134.704 152.841L130.308 153.148ZM131.232 134.781C130.57 134.827 129.997 134.64 129.514 134.22C129.031 133.8 128.768 133.279 128.724 132.657C128.68 132.025 128.868 131.472 129.289 130.999C129.709 130.516 130.25 130.251 130.912 130.205C131.575 130.159 132.147 130.345 132.631 130.765C133.113 131.175 133.376 131.697 133.421 132.329C133.464 132.951 133.276 133.504 132.856 133.987C132.436 134.47 131.895 134.735 131.232 134.781ZM137.654 152.635L136.526 136.498L140.921 136.191L141.11 138.9L141.201 138.894C141.467 137.948 141.978 137.171 142.732 136.563C143.496 135.955 144.42 135.613 145.504 135.538C146.257 135.485 146.943 135.568 147.563 135.787C148.184 136.006 148.717 136.347 149.163 136.81C149.618 137.272 149.957 137.853 150.177 138.554L150.267 138.547C150.46 137.848 150.781 137.236 151.228 136.71C151.685 136.174 152.235 135.748 152.878 135.43C153.531 135.112 154.254 134.926 155.047 134.87C156.101 134.797 157.04 134.958 157.864 135.354C158.689 135.75 159.35 136.339 159.848 137.121C160.347 137.903 160.634 138.841 160.711 139.935L161.482 150.968L157.087 151.276L156.392 141.341C156.349 140.719 156.206 140.199 155.966 139.783C155.735 139.365 155.416 139.06 155.009 138.866C154.612 138.672 154.128 138.595 153.556 138.635C153.004 138.674 152.526 138.833 152.122 139.114C151.728 139.393 151.432 139.767 151.232 140.235C151.033 140.702 150.955 141.237 150.997 141.839L151.683 151.654L147.453 151.949L146.749 141.879C146.708 141.297 146.568 140.808 146.329 140.411C146.089 140.014 145.766 139.724 145.36 139.541C144.964 139.347 144.494 139.269 143.952 139.307C143.4 139.345 142.923 139.51 142.52 139.8C142.116 140.091 141.81 140.475 141.602 140.953C141.403 141.431 141.325 141.976 141.368 142.588L142.049 152.327L137.654 152.635ZM169.087 150.694C168.013 150.769 167.055 150.629 166.214 150.275C165.371 149.91 164.694 149.377 164.181 148.677C163.677 147.966 163.393 147.139 163.327 146.196L163.325 146.166C163.256 145.182 163.443 144.327 163.886 143.6C164.329 142.863 165.003 142.262 165.908 141.795C166.813 141.328 167.93 141.003 169.258 140.819L175.523 139.988L175.715 142.728L170.11 143.483C169.271 143.592 168.643 143.837 168.226 144.219C167.808 144.592 167.619 145.064 167.659 145.636L167.661 145.666C167.703 146.258 167.961 146.709 168.436 147.018C168.911 147.318 169.53 147.441 170.292 147.388C170.945 147.342 171.518 147.176 172.012 146.889C172.516 146.592 172.898 146.212 173.158 145.75C173.427 145.278 173.542 144.76 173.503 144.198L173.161 139.306C173.111 138.594 172.846 138.048 172.366 137.668C171.885 137.278 171.213 137.113 170.35 137.173C169.527 137.231 168.886 137.447 168.429 137.822C167.971 138.197 167.705 138.649 167.631 139.179L167.61 139.316L163.591 139.597L163.594 139.416C163.605 138.416 163.869 137.511 164.387 136.698C164.915 135.884 165.676 135.226 166.669 134.723C167.672 134.209 168.881 133.903 170.296 133.804C171.69 133.706 172.915 133.848 173.971 134.228C175.025 134.598 175.862 135.169 176.481 135.943C177.109 136.716 177.462 137.644 177.537 138.728L178.311 149.792L173.916 150.099L173.747 147.691L173.657 147.697C173.395 148.27 173.037 148.774 172.583 149.209C172.139 149.633 171.623 149.977 171.036 150.24C170.449 150.493 169.799 150.644 169.087 150.694ZM187.592 149.475C185.805 149.6 184.454 149.317 183.539 148.624C182.623 147.932 182.105 146.723 181.984 144.997L181.403 136.688L179.16 136.845L178.929 133.533L181.172 133.376L180.896 129.432L185.336 129.122L185.612 133.066L188.563 132.859L188.794 136.171L185.844 136.377L186.391 144.205C186.444 144.957 186.646 145.473 186.998 145.751C187.36 146.018 187.872 146.128 188.534 146.082C188.735 146.068 188.91 146.05 189.06 146.03C189.209 145.999 189.348 145.969 189.477 145.94L189.702 149.161C189.464 149.218 189.166 149.275 188.807 149.33C188.458 149.395 188.053 149.443 187.592 149.475ZM192.205 148.82L191.076 132.684L195.472 132.376L196.6 148.513L192.205 148.82ZM193.129 130.453C192.466 130.499 191.894 130.312 191.411 129.892C190.927 129.472 190.664 128.951 190.621 128.329C190.576 127.697 190.765 127.144 191.185 126.671C191.605 126.188 192.146 125.923 192.809 125.877C193.471 125.83 194.044 126.017 194.527 126.437C195.009 126.847 195.273 127.368 195.317 128.001C195.36 128.623 195.172 129.175 194.752 129.659C194.332 130.142 193.791 130.406 193.129 130.453ZM206.979 148.12C205.344 148.234 203.905 147.997 202.664 147.408C201.423 146.819 200.432 145.92 199.692 144.712C198.952 143.503 198.521 142.025 198.399 140.279L198.397 140.249C198.276 138.513 198.503 137 199.078 135.709C199.653 134.408 200.513 133.38 201.661 132.624C202.808 131.868 204.184 131.434 205.79 131.322C207.405 131.209 208.834 131.447 210.075 132.036C211.326 132.614 212.326 133.507 213.076 134.715C213.825 135.913 214.261 137.385 214.383 139.131L214.385 139.161C214.508 140.918 214.282 142.446 213.707 143.747C213.143 145.047 212.287 146.075 211.14 146.83C209.992 147.576 208.605 148.006 206.979 148.12ZM206.753 144.672C207.466 144.622 208.07 144.388 208.565 143.97C209.069 143.542 209.437 142.951 209.666 142.199C209.905 141.436 209.988 140.528 209.914 139.474L209.912 139.444C209.839 138.4 209.632 137.522 209.289 136.81C208.947 136.098 208.497 135.57 207.938 135.226C207.379 134.871 206.743 134.719 206.031 134.769C205.328 134.818 204.725 135.057 204.22 135.486C203.725 135.903 203.358 136.489 203.118 137.242C202.878 137.995 202.795 138.893 202.868 139.937L202.87 139.967C202.943 141.02 203.147 141.909 203.48 142.632C203.822 143.344 204.273 143.877 204.832 144.231C205.39 144.575 206.031 144.722 206.753 144.672ZM217.222 147.071L216.094 130.934L220.489 130.627L220.674 133.276L220.765 133.27C221.122 132.317 221.693 131.546 222.479 130.957C223.264 130.367 224.264 130.03 225.479 129.945C227.255 129.821 228.662 130.262 229.701 131.269C230.748 132.264 231.339 133.71 231.471 135.607L232.2 146.023L227.804 146.331L227.139 136.817C227.065 135.764 226.758 134.968 226.216 134.432C225.683 133.884 224.925 133.644 223.942 133.713C223.29 133.759 222.733 133.949 222.273 134.284C221.811 134.608 221.464 135.046 221.23 135.597C221.006 136.147 220.919 136.778 220.969 137.491L221.618 146.763L217.222 147.071Z"
        fill="#374FD5"
      />
    </g>
    <g
      className="origin-top transition-transform delay-75 duration-300 group-hover:scale-105"
      filter="url(#filter2_dd_73_1295)"
    >
      <path
        d="M78.6263 151.935L77.1271 155.605C75.586 158.632 76.5702 162.292 79.4237 164.146L81.634 166.041L78.8881 165.074C75.7668 163.684 72.2595 164.751 70.343 167.355L67.9145 170.488L69.4137 166.819C70.9548 163.792 69.9706 160.131 67.1171 158.278L64.9068 156.383L67.6527 157.35C70.774 158.74 74.2813 157.672 76.1978 155.068L78.6263 151.935Z"
        fill="white"
      />
      <path
        d="M78.6263 151.935L77.1271 155.605C75.586 158.632 76.5702 162.292 79.4237 164.146L81.634 166.041L78.8881 165.074C75.7668 163.684 72.2595 164.751 70.343 167.355L67.9145 170.488L69.4137 166.819C70.9548 163.792 69.9706 160.131 67.1171 158.278L64.9068 156.383L67.6527 157.35C70.774 158.74 74.2813 157.672 76.1978 155.068L78.6263 151.935Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g
      className="origin-top transition-transform delay-150 duration-300 group-hover:scale-105"
      filter="url(#filter3_dd_73_1295)"
    >
      <path
        d="M276.826 155.902L278.52 157.654C279.841 159.27 282.145 159.623 283.894 158.476L285.507 157.701L284.283 159.007C282.729 160.419 282.461 162.657 283.452 164.379L284.614 166.521L282.92 164.769C281.598 163.153 279.295 162.801 277.546 163.948L275.933 164.722L277.157 163.417C278.711 162.005 278.979 159.767 277.988 158.044L276.826 155.902Z"
        fill="white"
      />
      <path
        d="M276.826 155.902L278.52 157.654C279.841 159.27 282.145 159.623 283.894 158.476L285.507 157.701L284.283 159.007C282.729 160.419 282.461 162.657 283.452 164.379L284.614 166.521L282.92 164.769C281.598 163.153 279.295 162.801 277.546 163.948L275.933 164.722L277.157 163.417C278.711 162.005 278.979 159.767 277.988 158.044L276.826 155.902Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g
      className="origin-top transition-transform delay-0 duration-300 group-hover:scale-105"
      filter="url(#filter4_d_73_1295)"
    >
      <path
        d="M15.1562 109.908C45.6218 92.0548 80.4359 65.1997 84.6979 27.1462C86.722 9.07406 68.4927 5.98805 62.5774 21.9414C57.8063 34.8088 54.3565 75.0417 51.6096 94.3668C48.8626 113.692 48.2642 116.35 48.2642 116.35C49.951 105.122 54.6256 82.5195 62.4328 73.2666C71.0123 63.0982 87.7278 60.6094 89.7579 77.4592C91.2037 89.4592 83.1073 107.387 91.0591 113.459C99.0108 119.531 118.962 114.326 127.348 108.688C130.145 106.997 132.803 105.263 132.803 105.263M132.797 105.268C140.347 100.736 148.928 92.9165 152.072 81.8604C155.178 70.937 148.527 63.987 140.505 63.7369C136.066 63.5985 131.206 65.5125 127.349 69.9412C119.918 78.4724 117.895 95.3184 126.047 104.956C130.05 110.378 139.462 115.468 150.77 115.437C160.703 115.409 172.098 111.41 182.577 100.158C184.831 97.7894 186.341 96.1335 186.589 95.8606C186.614 95.8336 186.637 95.8065 186.659 95.7779L186.843 95.547C193.375 87.31 206.347 70.9524 211.637 52.3025C215.966 37.0412 218.577 17.0256 210.77 13.2666C209.596 12.7012 208.384 12.4252 207.155 12.4297C199.307 12.4587 190.75 23.9332 186.625 44.5591C183.264 61.3635 182.577 70.23 182.577 82.9528C182.336 93.6515 185.469 116.321 203.975 116.784C225.517 117.322 241.025 97.041 247.782 86.5676C253.565 77.6038 263.442 57.8464 267.589 41.315C272.36 22.2946 269.817 15.6643 263.251 13.4115C255.01 10.5838 245.757 21.797 241.276 41.3149C237.185 59.131 232.89 82.664 238.095 97.7001C239.974 104.035 247.782 116.704 259.348 116.704C274.286 116.8 286.516 103.691 292.588 82.0048M292.588 82.0048C294.323 75.9326 300.858 63.7881 313.118 63.7881C328.443 63.7881 327.287 71.1618 338.275 70.8727C347.065 70.6414 353.986 64.6077 356.347 61.6197M292.588 82.0048C288.841 97.0408 290.865 117.282 310.226 116.414C328.385 115.605 333.31 97.571 333.503 88.6554C334.322 80.1253 331.363 63.7881 314.13 63.7881"
        stroke="white"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_73_1295"
        x="166.701"
        y="151.742"
        width="137.626"
        height="66.6539"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1295"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_73_1295"
        x="64.3333"
        y="102.52"
        width="193.878"
        height="82.5414"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1295"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_73_1295"
        x="36.2396"
        y="136.602"
        width="74.0609"
        height="75.8871"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1295"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1295"
          result="effect2_dropShadow_73_1295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1295"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_73_1295"
        x="247.266"
        y="140.569"
        width="66.9075"
        height="67.9524"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1295"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1295"
          result="effect2_dropShadow_73_1295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1295"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_73_1295"
        x="0.488607"
        y="0.246287"
        width="370.526"
        height="134.548"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1295"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const PlaygroundCard: React.FCC = () => (
  <a
    href="https://www.figma.com/community/file/1037503079763073886"
    target="_blank"
    rel="noreferrer"
  >
    <RoundedBackgroundCard
      bgStartClass="from-[#D5F5CC]"
      bgEndClass="to-[#D7E6FA]"
    >
      <div className="relative flex h-[350px] flex-col justify-end">
        <div className="absolute left-1/2 top-[calc(100%-140px)] h-[600px] w-[600px] -translate-x-1/2 transform-gpu rounded-full bg-[#1BC47D] blur-[120px] transition-transform duration-300 group-hover:-translate-y-10" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[70%]">
          {playgroundArt}
        </div>
        <div className="absolute inset-0 flex flex-row items-end justify-start gap-2 p-4">
          {figmaPlaygroundIcon}
          <Typography className="text-white" style="Body3Medium">
            Interactive tutorial
          </Typography>
        </div>
      </div>
    </RoundedBackgroundCard>
  </a>
)

const playgroundArt = (
  <svg
    width="180"
    height="192"
    viewBox="0 0 180 192"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 58H180V59H0V58Z" fill="url(#paint0_radial_73_1310)" />
    <path d="M0 118H180V119H0V118Z" fill="url(#paint1_radial_73_1310)" />
    <path
      d="M121 3.60366e-08L121 180H120L120 0L121 3.60366e-08Z"
      fill="url(#paint2_radial_73_1310)"
    />
    <path
      d="M61 3.60366e-08L61 180H60L60 0L61 3.60366e-08Z"
      fill="url(#paint3_radial_73_1310)"
    />
    <path
      className="transition-transform duration-300 group-hover:scale-x-[0.65]"
      opacity="0.5"
      d="M20 159.643H120"
      stroke="#1BC47D"
      strokeWidth="1.16071"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M44.5 19.6428L159.714 19.6428"
      stroke="#1BC47D"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      className="curve"
      d="M20 160C120 160 55 20 160 20"
      stroke="white"
      strokeWidth="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter0_d_73_1310)">
      <path
        d="M20 160C120 160 55 20 160 20"
        className="curve"
        stroke="white"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <circle
      cx="44.6429"
      cy="19.6429"
      r="4.14286"
      fill="#1BC47D"
      stroke="#1BC47D"
    />
    <circle
      className="transition-transform duration-300 group-hover:-translate-x-[40px]"
      cx="119.643"
      cy="159.643"
      r="4.64286"
      fill="#1BC47D"
    />
    <g
      className="transition-transform duration-300 group-hover:-translate-x-[40px]"
      filter="url(#filter1_d_73_1310)"
    >
      <path
        d="M124.75 181.5L121 162L137.5 171.75L129.25 174L124.75 181.5Z"
        fill="#010101"
      />
      <path
        d="M121.382 161.354L119.949 160.508L120.263 162.142L124.013 181.642L124.384 183.568L125.393 181.886L129.738 174.644L137.697 172.474L139.409 172.007L137.882 171.104L121.382 161.354Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_73_1310"
        x="5.33333"
        y="8.66667"
        width="169.333"
        height="169.333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1310"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_73_1310"
        x="114.398"
        y="156.016"
        width="31.4189"
        height="35.6197"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.5" />
        <feGaussianBlur stdDeviation="2.25" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1310"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1310"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_73_1310"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90 90) rotate(90) scale(93)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_73_1310"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90 90) rotate(90) scale(93)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_73_1310"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90 90) rotate(90) scale(93)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_73_1310"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90 90) rotate(90) scale(93)"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)

const figmaPlaygroundIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 9C15.7956 9 16.5587 9.31607 17.1213 9.87868C17.6839 10.4413 18 11.2044 18 12C18 12.7956 17.6839 13.5587 17.1213 14.1213C16.5587 14.6839 15.7956 15 15 15C14.2044 15 13.4413 14.6839 12.8787 14.1213C12.3161 13.5587 12 12.7956 12 12C12 11.2044 12.3161 10.4413 12.8787 9.87868C13.4413 9.31607 14.2044 9 15 9ZM15 9C15.7956 9 16.5587 8.68393 17.1213 8.12132C17.6839 7.55871 18 6.79565 18 6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H9C8.20435 3 7.44129 3.31607 6.87868 3.87868C6.31607 4.44129 6 5.20435 6 6C6 6.79565 6.31607 7.55871 6.87868 8.12132C7.44129 8.68393 8.20435 9 9 9M15 9H9M9 9C8.20435 9 7.44129 9.31607 6.87868 9.87868C6.31607 10.4413 6 11.2044 6 12C6 12.7956 6.31607 13.5587 6.87868 14.1213C7.44129 14.6839 8.20435 15 9 15M9 15H12M9 15C8.40666 15 7.82664 15.1759 7.33329 15.5056C6.83994 15.8352 6.45543 16.3038 6.22836 16.8519C6.0013 17.4001 5.94189 18.0033 6.05765 18.5853C6.1734 19.1672 6.45912 19.7018 6.87868 20.1213C7.29824 20.5409 7.83279 20.8266 8.41473 20.9424C8.99667 21.0581 9.59987 20.9987 10.1481 20.7716C10.6962 20.5446 11.1648 20.1601 11.4944 19.6667C11.8241 19.1734 12 18.5933 12 18V3"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const youtubeIcon = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7896 5.45155C20.6511 5.67894 21.3232 6.34469 21.5562 7.19488C22.1656 9.62039 22.1259 14.2061 21.569 16.6695C21.3386 17.5197 20.6639 18.1829 19.8024 18.4128C17.3701 19.0066 6.47597 18.9333 4.18449 18.4128C3.32294 18.1855 2.65086 17.5197 2.41787 16.6695C1.84308 14.3577 1.88277 9.46879 2.40507 7.20752C2.6355 6.35733 3.31014 5.6941 4.17169 5.46418C7.42328 4.79464 18.6323 5.01066 19.7896 5.45155ZM10.0604 8.97608L15.2834 11.9322L10.0604 14.8882V8.97608Z"
      stroke="white"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
)

const RoundedBackgroundCard: React.FCC<ICardProps> = ({
  children,
  bgStartClass,
  bgEndClass,
}) => (
  <div className="group relative h-full overflow-clip rounded-2xl">
    <div
      className={`absolute inset-0 bg-gradient-to-bl ${bgStartClass} ${bgEndClass} opacity-50 transition-all duration-300`}
    />
    {children}
  </div>
)

const InstallPluginBanner: React.FCC = () => (
  <a
    href="https://www.figma.com/community/plugin/988173868842375596"
    target="_blank"
    rel="noreferrer"
  >
    <RoundedBackgroundCard
      bgStartClass="from-[#D5F5CC]"
      bgEndClass="to-[#94CFFA]"
    >
      <div className="flex h-full w-full flex-col items-center justify-start gap-6">
        <div className="relative flex w-full flex-row items-center justify-between pr-6">
          <div className="flex flex-row gap-[26px]">
            <div>{art}</div>
            <div className="flex flex-col justify-center">
              <Typography style="Body2Medium" color="dark">
                Use our Figma plugin to create your first project.
              </Typography>
              <Typography style="Body4Regular" color="dark">
                Or explore these goodies for a quick start.
              </Typography>
            </div>
          </div>
          <div className="flex h-min flex-row items-center gap-2 rounded-lg bg-secondary px-4 py-2 text-white">
            {figmaIcon} <p>Install plugin</p>
          </div>
        </div>
      </div>
    </RoundedBackgroundCard>
  </a>
)

const figmaIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_73_1485)">
      <path
        d="M5.33357 16.0001C6.80552 16.0001 8.00014 14.8054 8.00014 13.3334V10.6667H5.33357C3.86162 10.6667 2.66699 11.8614 2.66699 13.3334C2.66699 14.8054 3.86162 16.0001 5.33357 16.0001Z"
        fill="#0ACF83"
      />
      <path
        d="M2.66699 7.99991C2.66699 6.52792 3.86162 5.33325 5.33357 5.33325H8.00014V10.6666H5.33357C3.86162 10.6666 2.66699 9.47191 2.66699 7.99991Z"
        fill="#A259FF"
      />
      <path
        d="M2.66699 2.66666C2.66699 1.19466 3.86162 0 5.33357 0H8.00014V5.33332H5.33357C3.86162 5.33332 2.66699 4.13866 2.66699 2.66666Z"
        fill="#F24E1E"
      />
      <path
        d="M7.99902 0H10.6656C12.1376 0 13.3322 1.19466 13.3322 2.66666C13.3322 4.13866 12.1376 5.33332 10.6656 5.33332H7.99902V0Z"
        fill="#FF7262"
      />
      <path
        d="M13.3322 7.99991C13.3322 9.47191 12.1376 10.6666 10.6656 10.6666C9.19365 10.6666 7.99902 9.47191 7.99902 7.99991C7.99902 6.52792 9.19365 5.33325 10.6656 5.33325C12.1376 5.33325 13.3322 6.52792 13.3322 7.99991Z"
        fill="#1ABCFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_73_1485">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const art = (
  <svg
    width="137"
    height="121"
    viewBox="0 0 137 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_73_1492)">
      <path
        d="M28.8579 81.6396L-8.43164 118.49"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter1_dd_73_1492)">
      <path
        d="M34.4854 43.1416L-53.749 80.3662"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter2_dd_73_1492)">
      <path
        d="M65.7722 77.6699L36.0605 149.797"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter3_dd_73_1492)">
      <path
        d="M45.6645 88.5303C58.9659 88.5303 69.7489 77.7661 69.7489 64.4878C69.7489 51.2095 58.9659 40.4453 45.6645 40.4453C32.363 40.4453 21.5801 51.2095 21.5801 64.4878C21.5801 77.7661 32.363 88.5303 45.6645 88.5303Z"
        fill="white"
      />
      <path
        d="M45.6645 88.5303C58.9659 88.5303 69.7489 77.7661 69.7489 64.4878C69.7489 51.2095 58.9659 40.4453 45.6645 40.4453C32.363 40.4453 21.5801 51.2095 21.5801 64.4878C21.5801 77.7661 32.363 88.5303 45.6645 88.5303Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M34.4854 43.1416L-53.749 80.3662"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter4_d_73_1492)">
      <path
        d="M-16.4484 78.4971L-16.2233 80.1448C-16.1483 81.5679 -15.0229 82.6914 -13.5973 82.7663L-12.3968 82.991L-13.5973 83.2157C-15.0229 83.3655 -16.0733 84.489 -16.2233 85.8371L-16.4484 87.4849L-16.6735 85.8371C-16.7485 84.4141 -17.874 83.2906 -19.2995 83.2157L-20.5 82.991L-19.2995 82.7663C-17.874 82.6165 -16.8236 81.493 -16.6735 80.1448L-16.4484 78.4971Z"
        fill="white"
      />
      <path
        d="M-16.4484 78.4971L-16.2233 80.1448C-16.1483 81.5679 -15.0229 82.6914 -13.5973 82.7663L-12.3968 82.991L-13.5973 83.2157C-15.0229 83.3655 -16.0733 84.489 -16.2233 85.8371L-16.4484 87.4849L-16.6735 85.8371C-16.7485 84.4141 -17.874 83.2906 -19.2995 83.2157L-20.5 82.991L-19.2995 82.7663C-17.874 82.6165 -16.8236 81.493 -16.6735 80.1448L-16.4484 78.4971Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter5_dd_73_1492)">
      <path
        d="M91.5516 101.994L91.7767 103.642C91.8517 105.065 92.9771 106.188 94.4027 106.263L95.6032 106.488L94.4027 106.713C92.9771 106.863 91.9267 107.986 91.7767 109.334L91.5516 110.982L91.3265 109.334C91.2515 107.911 90.126 106.788 88.7005 106.713L87.5 106.488L88.7005 106.263C90.126 106.114 91.1764 104.99 91.3265 103.642L91.5516 101.994Z"
        fill="white"
      />
      <path
        d="M91.5516 101.994L91.7767 103.642C91.8517 105.065 92.9771 106.188 94.4027 106.263L95.6032 106.488L94.4027 106.713C92.9771 106.863 91.9267 107.986 91.7767 109.334L91.5516 110.982L91.3265 109.334C91.2515 107.911 90.126 106.788 88.7005 106.713L87.5 106.488L88.7005 106.263C90.126 106.114 91.1764 104.99 91.3265 103.642L91.5516 101.994Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter6_dd_73_1492)">
      <path
        d="M19.5516 2.99414L19.7767 4.64191C19.8517 6.06499 20.9771 7.18847 22.4027 7.26336L23.6032 7.48806L22.4027 7.71276C20.9771 7.86255 19.9267 8.98603 19.7767 10.3342L19.5516 11.982L19.3265 10.3342C19.2515 8.91113 18.126 7.78765 16.7005 7.71276L15.5 7.48806L16.7005 7.26336C18.126 7.11357 19.1764 5.99009 19.3265 4.64191L19.5516 2.99414Z"
        fill="white"
      />
      <path
        d="M19.5516 2.99414L19.7767 4.64191C19.8517 6.06499 20.9771 7.18847 22.4027 7.26336L23.6032 7.48806L22.4027 7.71276C20.9771 7.86255 19.9267 8.98603 19.7767 10.3342L19.5516 11.982L19.3265 10.3342C19.2515 8.91113 18.126 7.78765 16.7005 7.71276L15.5 7.48806L16.7005 7.26336C18.126 7.11357 19.1764 5.99009 19.3265 4.64191L19.5516 2.99414Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter7_dd_73_1492)">
      <path
        d="M77.0006 49.9901C77.8293 49.9901 78.5012 49.3194 78.5012 48.4921C78.5012 47.6648 77.8293 46.9941 77.0006 46.9941C76.1718 46.9941 75.5 47.6648 75.5 48.4921C75.5 49.3194 76.1718 49.9901 77.0006 49.9901Z"
        fill="white"
      />
      <path
        d="M77.0006 49.9901C77.8293 49.9901 78.5012 49.3194 78.5012 48.4921C78.5012 47.6648 77.8293 46.9941 77.0006 46.9941C76.1718 46.9941 75.5 47.6648 75.5 48.4921C75.5 49.3194 76.1718 49.9901 77.0006 49.9901Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter8_dd_73_1492)">
      <path
        d="M81.0006 94.9901C81.8293 94.9901 82.5012 94.3194 82.5012 93.4921C82.5012 92.6648 81.8293 91.9941 81.0006 91.9941C80.1718 91.9941 79.5 92.6648 79.5 93.4921C79.5 94.3194 80.1718 94.9901 81.0006 94.9901Z"
        fill="white"
      />
      <path
        d="M81.0006 94.9901C81.8293 94.9901 82.5012 94.3194 82.5012 93.4921C82.5012 92.6648 81.8293 91.9941 81.0006 91.9941C80.1718 91.9941 79.5 92.6648 79.5 93.4921C79.5 94.3194 80.1718 94.9901 81.0006 94.9901Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter9_dd_73_1492)">
      <path
        d="M28.525 66.3583C29.3538 66.3583 30.0256 65.6876 30.0256 64.8603C30.0256 64.033 29.3538 63.3623 28.525 63.3623C27.6962 63.3623 27.0244 64.033 27.0244 64.8603C27.0244 65.6876 27.6962 66.3583 28.525 66.3583Z"
        fill="white"
      />
      <path
        d="M28.525 66.3583C29.3538 66.3583 30.0256 65.6876 30.0256 64.8603C30.0256 64.033 29.3538 63.3623 28.525 63.3623C27.6962 63.3623 27.0244 64.033 27.0244 64.8603C27.0244 65.6876 27.6962 66.3583 28.525 66.3583Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter10_dd_73_1492)">
      <path
        d="M44.5064 119.836C45.3352 119.836 46.007 119.165 46.007 118.338C46.007 117.511 45.3352 116.84 44.5064 116.84C43.6777 116.84 43.0059 117.511 43.0059 118.338C43.0059 119.165 43.6777 119.836 44.5064 119.836Z"
        fill="white"
      />
      <path
        d="M44.5064 119.836C45.3352 119.836 46.007 119.165 46.007 118.338C46.007 117.511 45.3352 116.84 44.5064 116.84C43.6777 116.84 43.0059 117.511 43.0059 118.338C43.0059 119.165 43.6777 119.836 44.5064 119.836Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter11_dd_73_1492)">
      <path
        d="M39.0006 29.9901C39.8293 29.9901 40.5012 29.3194 40.5012 28.4921C40.5012 27.6648 39.8293 26.9941 39.0006 26.9941C38.1718 26.9941 37.5 27.6648 37.5 28.4921C37.5 29.3194 38.1718 29.9901 39.0006 29.9901Z"
        fill="white"
      />
      <path
        d="M39.0006 29.9901C39.8293 29.9901 40.5012 29.3194 40.5012 28.4921C40.5012 27.6648 39.8293 26.9941 39.0006 26.9941C38.1718 26.9941 37.5 27.6648 37.5 28.4921C37.5 29.3194 38.1718 29.9901 39.0006 29.9901Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter12_d_73_1492)">
      <path
        d="M-11.9994 51.9901C-11.1707 51.9901 -10.4988 51.3194 -10.4988 50.4921C-10.4988 49.6648 -11.1707 48.9941 -11.9994 48.9941C-12.8282 48.9941 -13.5 49.6648 -13.5 50.4921C-13.5 51.3194 -12.8282 51.9901 -11.9994 51.9901Z"
        fill="white"
      />
      <path
        d="M-11.9994 51.9901C-11.1707 51.9901 -10.4988 51.3194 -10.4988 50.4921C-10.4988 49.6648 -11.1707 48.9941 -11.9994 48.9941C-12.8282 48.9941 -13.5 49.6648 -13.5 50.4921C-13.5 51.3194 -12.8282 51.9901 -11.9994 51.9901Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter13_d_73_1492)">
      <path
        d="M-10.7904 89.0526C-9.96168 89.0526 -9.28984 88.3819 -9.28984 87.5546C-9.28984 86.7273 -9.96168 86.0566 -10.7904 86.0566C-11.6192 86.0566 -12.291 86.7273 -12.291 87.5546C-12.291 88.3819 -11.6192 89.0526 -10.7904 89.0526Z"
        fill="white"
      />
      <path
        d="M-10.7904 89.0526C-9.96168 89.0526 -9.28984 88.3819 -9.28984 87.5546C-9.28984 86.7273 -9.96168 86.0566 -10.7904 86.0566C-11.6192 86.0566 -12.291 86.7273 -12.291 87.5546C-12.291 88.3819 -11.6192 89.0526 -10.7904 89.0526Z"
        stroke="white"
      />
    </g>
    <g filter="url(#filter14_dd_73_1492)">
      <path
        d="M1.28965 117.664C2.1184 117.664 2.79023 116.993 2.79023 116.166C2.79023 115.339 2.1184 114.668 1.28965 114.668C0.460898 114.668 -0.210938 115.339 -0.210938 116.166C-0.210938 116.993 0.460898 117.664 1.28965 117.664Z"
        fill="white"
      />
      <path
        d="M1.28965 117.664C2.1184 117.664 2.79023 116.993 2.79023 116.166C2.79023 115.339 2.1184 114.668 1.28965 114.668C0.460898 114.668 -0.210938 115.339 -0.210938 116.166C-0.210938 116.993 0.460898 117.664 1.28965 117.664Z"
        stroke="white"
      />
    </g>
    <path
      opacity="0.4"
      d="M34.4853 77.3703C35.4798 77.3703 36.286 76.5655 36.286 75.5727C36.286 74.5799 35.4798 73.7751 34.4853 73.7751C33.4908 73.7751 32.6846 74.5799 32.6846 75.5727C32.6846 76.5655 33.4908 77.3703 34.4853 77.3703Z"
      fill="#5A87BF"
    />
    <path
      opacity="0.2"
      d="M29.9081 65.6861C30.9026 65.6861 31.7088 64.8813 31.7088 63.8885C31.7088 62.8957 30.9026 62.0909 29.9081 62.0909C28.9136 62.0909 28.1074 62.8957 28.1074 63.8885C28.1074 64.8813 28.9136 65.6861 29.9081 65.6861Z"
      fill="#5A87BF"
    />
    <path
      opacity="0.1"
      d="M35.7607 54.0019C36.7552 54.0019 37.5614 53.1971 37.5614 52.2043C37.5614 51.2115 36.7552 50.4067 35.7607 50.4067C34.7662 50.4067 33.96 51.2115 33.96 52.2043C33.96 53.1971 34.7662 54.0019 35.7607 54.0019Z"
      fill="#5A87BF"
    />
    <path
      opacity="0.5"
      d="M46.2646 82.014C47.2591 82.014 48.0653 81.2092 48.0653 80.2164C48.0653 79.2236 47.2591 78.4188 46.2646 78.4188C45.2701 78.4188 44.4639 79.2236 44.4639 80.2164C44.4639 81.2092 45.2701 82.014 46.2646 82.014Z"
      fill="#5A87BF"
    />
    <path
      opacity="0.6"
      d="M57.9687 76.2467C58.9632 76.2467 59.7694 75.4419 59.7694 74.4492C59.7694 73.4564 58.9632 72.6516 57.9687 72.6516C56.9742 72.6516 56.168 73.4564 56.168 74.4492C56.168 75.4419 56.9742 76.2467 57.9687 76.2467Z"
      fill="#5A87BF"
    />
    <g filter="url(#filter15_d_73_1492)">
      <circle cx="78.3145" cy="16.3474" r="7.48538" fill="white" />
      <circle
        cx="78.3145"
        cy="16.3474"
        r="7.48538"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter16_dd_73_1492)">
      <path
        d="M90.6311 23.4585C91.1836 22.5016 89.2038 20.244 85.7997 17.6796M65.9975 9.23629C66.3329 8.6554 67.5498 8.64295 69.3318 9.09546C70.0053 9.26648 70.7596 9.50391 71.5774 9.80217"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <circle
      cx="78.3145"
      cy="16.3474"
      r="7.48538"
      fill="white"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter17_d_73_1492)">
      <path
        d="M90.6307 23.4586C89.8039 24.8906 83.6192 22.8678 76.8168 18.9405C70.0144 15.0131 65.1703 10.6684 65.9971 9.23633"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g filter="url(#filter18_dd_73_1492)">
      <path
        d="M104.552 39.4971L104.777 41.1448C104.852 42.5679 105.977 43.6914 107.403 43.7663L108.603 43.991L107.403 44.2157C105.977 44.3655 104.927 45.489 104.777 46.8371L104.552 48.4849L104.326 46.8371C104.251 45.4141 103.126 44.2906 101.7 44.2157L100.5 43.991L101.7 43.7663C103.126 43.6165 104.176 42.493 104.326 41.1448L104.552 39.4971Z"
        fill="white"
      />
      <path
        d="M104.552 39.4971L104.777 41.1448C104.852 42.5679 105.977 43.6914 107.403 43.7663L108.603 43.991L107.403 44.2157C105.977 44.3655 104.927 45.489 104.777 46.8371L104.552 48.4849L104.326 46.8371C104.251 45.4141 103.126 44.2906 101.7 44.2157L100.5 43.991L101.7 43.7663C103.126 43.6165 104.176 42.493 104.326 41.1448L104.552 39.4971Z"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_73_1492"
        x="-37.0983"
        y="66.3063"
        width="94.6234"
        height="94.1834"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_73_1492"
        x="-82.4167"
        y="27.8078"
        width="145.57"
        height="94.5589"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_73_1492"
        x="7.39291"
        y="62.3361"
        width="87.0462"
        height="129.462"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_73_1492"
        x="-7.08659"
        y="25.112"
        width="105.502"
        height="105.418"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_73_1492"
        x="-48.6667"
        y="63.6637"
        width="64.4368"
        height="65.3211"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_dd_73_1492"
        x="59.3333"
        y="87.1608"
        width="64.4368"
        height="65.3211"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_dd_73_1492"
        x="-12.6667"
        y="-11.8392"
        width="64.4368"
        height="65.3211"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_dd_73_1492"
        x="48.8333"
        y="33.6608"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_dd_73_1492"
        x="52.8333"
        y="78.6608"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_dd_73_1492"
        x="0.35775"
        y="50.029"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_dd_73_1492"
        x="16.3392"
        y="103.507"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter11_dd_73_1492"
        x="10.8333"
        y="13.6608"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter12_d_73_1492"
        x="-40.1667"
        y="35.6608"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter13_d_73_1492"
        x="-38.9577"
        y="72.7233"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter14_dd_73_1492"
        x="-26.8776"
        y="101.335"
        width="56.3343"
        height="56.3293"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter15_d_73_1492"
        x="62.1624"
        y="3.52873"
        width="32.304"
        height="32.304"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter16_dd_73_1492"
        x="37.3304"
        y="-6.55709"
        width="82.0599"
        height="72.0159"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter17_d_73_1492"
        x="57.2386"
        y="3.90263"
        width="42.0589"
        height="32.0161"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_73_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter18_dd_73_1492"
        x="72.3333"
        y="24.6637"
        width="64.4368"
        height="65.3211"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="13.3333" />
        <feGaussianBlur stdDeviation="13.3333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.2 0"
        />
        <feBlend
          mode="multiply"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_73_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.33333" />
        <feGaussianBlur stdDeviation="3.33333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.352941 0 0 0 0 0.529412 0 0 0 0 0.74902 0 0 0 0.3 0"
        />
        <feBlend
          mode="multiply"
          in2="effect1_dropShadow_73_1492"
          result="effect2_dropShadow_73_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_73_1492"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
